import React from 'react';
import Container from '@/container';
import {Grid, Row, Col} from '@/grid';
import {withGreen800, withNeutral800} from '@/hocs/withColors';
import {H1, P} from '@/typography';
import Link from '@/links';
import {withHomeSubP} from '@/hocs/withFontType';
import PictureWrapper from '@/ui/images-wrapper';
import {withMarginTopZeroToXxl} from '@/hocs/withSpacing';
import {SectionPaddingHeroToZero} from '@/section';
import withBreakpoints from '@/hocs/withBreakpoints';

const imgPath = '/static/images/roi-calculator/hero/';

const H1Green800 = withGreen800(H1);
const SubPNeutral800 = withNeutral800(withHomeSubP(P));
const SectionHero = withMarginTopZeroToXxl(SectionPaddingHeroToZero);
const ContainerHero = withMarginTopZeroToXxl(Container);
const DivMarginTopMobile = withMarginTopZeroToXxl('div');

const ResponsiveHeroImg = withBreakpoints({
  desktop: props => (
    <PictureWrapper
      imgPath={imgPath}
      imageUrl="hero-desktop"
      imageTypeFallback="jpg"
      alt="Workable ROI calculator"
      fetchpriority="high"
      loading="eager"
    />
  ),
  mobile: props => (
    <DivMarginTopMobile>
      <PictureWrapper
        imgPath={imgPath}
        imageUrl="hero-mobile"
        imageTypeFallback="jpg"
        alt="Workable ROI calculator"
        fetchpriority="high"
        loading="eager"
      />
    </DivMarginTopMobile>
  )
});

const RoiCalculatorHero = () => (
  <SectionHero>
    <ContainerHero>
      <Grid fluid>
        <Row center="xs" start="lg" middle="lg">
          <Col xs={12} lg={6}>
            <H1Green800>Discover Workable’s impact on your hiring</H1Green800>
            <SubPNeutral800>
              Considering Workable for your recruiting needs? Our ATS ROI calculator helps you
              understand the potential impact of Workable on your hiring process, productivity, and
              bottom line.
            </SubPNeutral800>
            <Link
              href="#formContainer"
              variant="secondary"
              linkTitle="Read our security white paper">
              Calculate my ROI
            </Link>
          </Col>
          <Col xs={12} lg={6}>
            <ResponsiveHeroImg />
          </Col>
        </Row>
      </Grid>
    </ContainerHero>
  </SectionHero>
);

export default RoiCalculatorHero;
